import React, { Component } from 'react';
import masterCardIcon from './../../img/card-icon.svg';
import visaCardIcon from './../../img/visa-icon.svg';
import visaCardIconWhite from './../../img/visa-icon-white.svg';
import cardBlueBackground from './../../img/card-blue-background.svg';
import cardTransparentBackground from './../../img/card-transparent-background.svg';
import cardBlockIcon from './../../img/card-block-icon.png';
import { request } from './../../../../config';
import { translate } from 'react-i18next';
import YesNoModal from './../../../../copms/Modal/YesNoModal';
import NotFound from '../../../../copms/NotFound/NotFound';
import Loading from './../../Loading/Loading';
import digitalCard from './../../img/digital_card.svg';
import otherCard from './../../img/other-bank-card.svg';
import { cardTypes, maskCardNumber, setPaymentTypeIcon } from '../../../../helpers/cards';
import smsConfirmationIcon from './../../img/sms-confirmation-icon.svg';
import commentAltLines from './../../img/comment-alt-lines.svg';

class PINChange extends Component {
    state = {
        card: null,
        open: false,
        isLoading: false,
        focusedInputIndex: 0,
        step: 0,
        timer: 180,
        mobile: null,
        fromDigitalOrder: false,
        code: Array(4).fill(null).map(() => React.createRef())
    }

    showCard = () => {
        this.setState({ isLoading: true });
        let customerType = localStorage.getItem('compId') == null ? 'Individual' : 'Juridical';
        let getCardByIdForCustomerRequestBody = (customerType === 'Individual') ? {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("card/getCardByIdFor" + customerType, getCardByIdForCustomerRequestBody))
            .then(res => res.text())
            .then((getCardByIdForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardByIdForCustomerResponse = JSON.parse(getCardByIdForCustomerResponseJSON);
                if (getCardByIdForCustomerResponse.status.statusCode !== 1) {
                    if (getCardByIdForCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    if (getCardByIdForCustomerResponse?.otherCard) {
                        this.setState({ card: getCardByIdForCustomerResponse.otherCard });
                        this.setState({ isLoading: false });
                    } else {
                        // =========HOLDER=========
                        let holderArray = getCardByIdForCustomerResponse.holder.split(' ');
                        let lowercaseName = holderArray[0].toLowerCase();
                        let lowercaseSurname = holderArray[1].toLowerCase();
                        getCardByIdForCustomerResponse.organizedHolder = {
                            name: holderArray[0][0] + lowercaseName.substring(1, lowercaseName.length),
                            surname: holderArray[1][0] + lowercaseSurname.substring(1, lowercaseSurname.length)
                        };
                        getCardByIdForCustomerResponse.organizedCardNumber = getCardByIdForCustomerResponse.cardNumber.substring(0, 4)
                            + " **** **** " + getCardByIdForCustomerResponse.cardNumber.substring(12, 16);
                        let expiryDate = new Date(getCardByIdForCustomerResponse.expiryDate);
                        getCardByIdForCustomerResponse.organizedExpiryDate = {
                            month: (expiryDate.getMonth() < 9) ? ('0' + (expiryDate.getMonth() + 1)) : (expiryDate.getMonth() + 1),
                            year: expiryDate.getFullYear().toString().substring(2, 4),
                            fullYear: expiryDate.getFullYear(),
                            day: expiryDate.getDate() < 10 ? '0' + expiryDate.getDate().toString() : expiryDate.getDate().toString()
                        }
                        this.setState({ card: getCardByIdForCustomerResponse });
                        this.setState({ isLoading: false });
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    maskPhone = (phone) => {
        return '+' + phone.slice(0, 3) + '***' + phone.slice(-4);
    }

    sendOtpForCardPinChange = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') == null ? 'Individual' : 'Juridical';
        let sendOtpForCardPinChangeRequestBody = (customerType === 'Individual') ? {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            mobile: JSON.parse(localStorage.getItem('custObject')).mobile,
        } : {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            mobile: JSON.parse(localStorage.getItem('custObject')).customer.mobile,
        }
        fetch(request("card/sendOtpForCardPinChange", sendOtpForCardPinChangeRequestBody))
            .then(res => res.text())
            .then((sendOtpForCardPinChangeResponseJSON) => {
                const JSON = require('true-json-bigint');
                let sendOtpForCardPinChangeResponse = JSON.parse(sendOtpForCardPinChangeResponseJSON);
                if (sendOtpForCardPinChangeResponse.status.statusCode === 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let code = this.state.code;
                    code.forEach(ref => {
                        if (ref?.current) {
                            ref.current.value = "";
                            ref.current.disabled = false;
                        }
                    });
                    this.setState({ verifyToken: sendOtpForCardPinChangeResponse.verifyToken, mobile: this.maskPhone(sendOtpForCardPinChangeRequestBody.mobile), step: 3, code: code.length === 6 ? code : [...code, ...Array(2).fill(null).map(() => React.createRef())] }, () => {
                        setTimeout(() => code[0]?.current?.focus(), 0)
                        this.setTimer()
                    })
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(sendOtpForCardPinChangeResponse.status.statusCode));
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    cardPinChangeV2 = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') == null ? 'Individual' : 'Juridical';
        let sendOtpForCardPinChangeRequestBody = {
            custId: localStorage.getItem('custId'),
            newPin: this.state.pin,
            token: localStorage.getItem('token'),
            cardId: this.state.card.cardId,
            verifyToken: this.state.verifyToken,
            confirmCode: this.state.confirmCode
        }
        if (customerType === 'Juridical') {
            sendOtpForCardPinChangeRequestBody.compId = localStorage.getItem('compId')
        }
        fetch(request("card/cardPinChangeV2", sendOtpForCardPinChangeRequestBody))
            .then(res => res.text())
            .then((sendOtpForCardPinChangeResponseJSON) => {
                const JSON = require('true-json-bigint');
                let sendOtpForCardPinChangeResponse = JSON.parse(sendOtpForCardPinChangeResponseJSON);
                if (sendOtpForCardPinChangeResponse.status.statusCode === 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'success', this.props.t(this.state.fromDigitalOrder ? "Your card order has been created, please wait for notification of your contract signing" : "Your new PIN code has been successfully assigned", { cardNumber: this.state.card.organizedCardNumber }), null, null, false, () => this.props.history.push('/dashboard/home'));
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'error', this.props.t(sendOtpForCardPinChangeResponse.status.statusCode, { cardNumber: this.state.card.organizedCardNumber }));
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");

                });
    }

    componentDidMount() {
        this.showCard();
        if (this.props.location.state?.digital) {
            this.setState({ step: 1, fromDigitalOrder: true })
        }
    }

    unblockFunc = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let cardPinCodeUnblockRequestBody = customerType == 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            cardNumber: this.state.card.cardNumber,
            cardId: this.state.card.cardId,
            currency: this.state.card.currency
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            cardNumber: this.state.card.cardNumber,
            cardId: this.state.card.cardId,
            currency: this.state.card.currency
        }
        fetch(request("card/cardPinCodeUnblock", cardPinCodeUnblockRequestBody))
            .then(res => res.text())
            .then((cardPinCodeUnblockResponseJSON) => {
                const JSON = require('true-json-bigint');
                let cardPinCodeUnblockResponse = JSON.parse(cardPinCodeUnblockResponseJSON);
                if (cardPinCodeUnblockResponse.status.statusCode === 1) {
                    this.setState({ step: 0 })
                    this.props.alertState(true, 'success', this.props.t("Resetting of attempts to enter PIN", { cardNumber: this.state.card.organizedCardNumber }));
                }
                else {
                    if (cardPinCodeUnblockResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t(cardPinCodeUnblockResponse.status.statusCode, { cardNumber: this.state.card.organizedCardNumber }));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            });
    }

    setCardsBackground = (status, type) => {
        if (status) {
            if (type === cardTypes.DIGITAL_CARD || type === cardTypes.DIGITAL) {
                return <img src={digitalCard} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="active-digital-card" />
            } else if (type === cardTypes.CARD_STORAGE) {
                return <img src={otherCard} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="card-storage" />
            }
            else {
                return <img src={cardBlueBackground} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="cardBlueBackground" />
            }
        } else {
            if (type === cardTypes.DIGITAL_CARD || type === cardTypes.DIGITAL) {
                return <img src={digitalCard} className="dashboard-finance-section-card-section-details-section-content-card-background deactive-card" alt="deactive-digital-card" />
            } else if (type === cardTypes.CARD_STORAGE) {
                return <img src={otherCard} className="dashboard-finance-section-card-section-details-section-content-card-background deactive-card" alt="card-storage" />
            }
            else {
                return <img src={cardTransparentBackground} className="dashboard-finance-section-card-section-details-section-content-card-background" alt="cardTransparentBackground" />
            }
        }
    }

    insertCodeNumber = (number) => {
        let { focusedInputIndex, code } = this.state;
        const element = code[focusedInputIndex]?.current;

        if (!element) return;

        const cleanValue = String(number).replace(/\D/g, '').substring(0, 1);
        element.value = cleanValue;

        if (focusedInputIndex < code.length - 1 && cleanValue) {
            this.setState({ focusedInputIndex: focusedInputIndex + 1 }, () =>
                code[focusedInputIndex + 1]?.current?.focus()
            );
        } else if (focusedInputIndex === code.length - 1) {
            this.setState({ focusedInputIndex: -1 }, () => {
                element.blur();
            });
        }
    };

    deleteCodeNumber = (index, event) => {
        let { code } = this.state;
        if (event.key === "Backspace") {
            const element = code[index]?.current;

            if (!element) return;

            if (element.value) {
                element.value = "";
            } else if (index > 0) {
                const prevElement = code[index - 1]?.current;
                if (prevElement) {
                    prevElement.value = "";
                    this.setState({ focusedInputIndex: index - 1 }, () => {
                        prevElement.focus();
                    });
                }
            }
        }
    };

    handleFocus = (index) => {
        this.setState({ focusedInputIndex: index })
    }

    fancyTimeFormat = (duration) => {
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;
        var ret = "";
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    setTimer = () => {
        this.setState({ timer: 180 }, () => {
            this.timerInt = setInterval(() => {
                this.setState(prevState => {
                    if (prevState.timer <= 1) {
                        clearInterval(this.timerInt);
                        return { timer: 0 };
                    }
                    return { timer: prevState.timer - 1 };
                });
            }, 1000);
        });
    };

    continue = (e) => {
        e.preventDefault();
        let { code } = this.state;
        const value = code.map(item => item.current.value).join('')
        this.setState(prevState => ({ ...(prevState.step === 1 ? { pin: value } : prevState.step === 2 ? { rePin: value } : { confirmCode: value }), focusedInputIndex: 0 }), () => {
            code.forEach(ref => {
                if (ref?.current) {
                    ref.current.value = "";
                    ref.current.disabled = false;
                }
            })
            if (this.state.step == 2) {
                this.state.pin !== this.state.rePin ?
                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t("The PIN was entered incorrectly"))
                    :
                    this.sendOtpForCardPinChange()
            } else if (this.state.step == 3) {
                this.cardPinChangeV2();
            } else {
                this.setState({ step: 2 })
            }
        });
        setTimeout(() => code[0]?.current?.focus(), 0)
    }

    render() {
        let { card, open, isLoading, step, feedbackMessage, timer, code, mobile } = this.state;
        let { t } = this.props;
        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('pin_settings')}</h2>
                    </div>
                </div>
                {isLoading ?
                    <div className="dashboard-container-main-section"><Loading /></div> : !card ? <NotFound /> : <>
                        <YesNoModal onClose={() => this.setState({ open: false })} title={t('Change / set the PIN code of the card')} body={t('New pin content')} open={open} triggerFunc={() => this.setState({ step: 1, code: Array(4).fill(null).map(() => React.createRef()) }, () => { setTimeout(() => code[0]?.current?.focus(), 0); })} />
                        <div className="dashboard-container-main-section">
                            <div className="dashboard-finance-section-card-section">
                                <div className="dashboard-finance-section-card-section-details-section" style={{ width: '46%' }}>
                                    <div className="dashboard-finance-section-card-section-details-section-background">
                                        <div className="dashboard-finance-section-card-section-details-section-header">
                                            {
                                                card && card.cardId !== undefined &&
                                                <div className="dashboard-finance-section-card-section-details-section-header-left-side">
                                                    <img src={setPaymentTypeIcon(card.cardPaymentType, masterCardIcon, visaCardIcon)} className="dashboard-finance-section-card-section-details-section-header-image" alt="cardIcon" />
                                                    <h3 className="dashboard-finance-section-card-section-details-section-header-card-number">{card.cardType}</h3>
                                                </div>
                                            }
                                        </div>
                                        <div className="dashboard-finance-section-card-section-details-section-content pb-4">
                                            <div className="dashboard-finance-section-card-section-details-section-content-card">
                                                {this.setCardsBackground(card.cardStatus, card.cardType)}
                                                <div className="dashboard-finance-section-card-section-details-section-content-card-item dashboard-finance-section-card-section-details-section-content-other-card-item">
                                                    {
                                                        card && card.cardId !== undefined &&
                                                        <img src={setPaymentTypeIcon(card.cardPaymentType, masterCardIcon, visaCardIconWhite)} className="dashboard-finance-section-card-section-details-section-content-card-item-logo" alt="cardIcon" />
                                                    }
                                                    {
                                                        card && card.cardId !== undefined &&
                                                        <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-section">
                                                            <h4 className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-content">{card.cardType === cardTypes.CARD_STORAGE ? maskCardNumber(card.cardNumber) : card.organizedCardNumber}</h4>
                                                            <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-number-title">{t('card number')}</p>
                                                        </div>
                                                    }
                                                    {
                                                        card && card.cardId !== undefined && card.cardType !== cardTypes.CARD_STORAGE &&
                                                        <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-details-section mt-4">
                                                            <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-section">
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-name">{card.organizedHolder.name} {card.organizedHolder.surname}</p>
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-owner-title">{t("owner's name")}</p>
                                                            </div>
                                                            <div className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-section">
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-date">{card.organizedExpiryDate.month} / {card.organizedExpiryDate.year}</p>
                                                                <p className="dashboard-finance-section-card-section-details-section-content-card-item-card-valid-title">{t('it is reliable')}</p>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {card && card.cardId !== undefined && card.cardType !== cardTypes.CARD_STORAGE &&
                                                <ul className="dashboard-finance-section-card-section-details-section-content-list">
                                                    <li className="dashboard-finance-section-card-section-details-section-content-list-pin-item">
                                                        <button onClick={() => this.setState({ open: true, step: 0 })}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
                                                                <path d="M22.5 0.625H2.5C1.97917 0.651042 1.53646 0.833333 1.17188 1.17188C0.833333 1.53646 0.651042 1.97917 0.625 2.5V12.5C0.651042 13.0208 0.833333 13.4635 1.17188 13.8281C1.53646 14.1667 1.97917 14.349 2.5 14.375H22.5C23.0208 14.349 23.4635 14.1667 23.8281 13.8281C24.1667 13.4635 24.349 13.0208 24.375 12.5V2.5C24.349 1.97917 24.1667 1.53646 23.8281 1.17188C23.4635 0.833333 23.0208 0.651042 22.5 0.625ZM2.5 0H22.5C23.2031 0.0260417 23.7891 0.273438 24.2578 0.742188C24.7266 1.21094 24.974 1.79688 25 2.5V12.5C24.974 13.2031 24.7266 13.7891 24.2578 14.2578C23.7891 14.7266 23.2031 14.974 22.5 15H2.5C1.79688 14.974 1.21094 14.7266 0.742188 14.2578C0.273438 13.7891 0.0260417 13.2031 0 12.5V2.5C0.0260417 1.79688 0.273438 1.21094 0.742188 0.742188C1.21094 0.273438 1.79688 0.0260417 2.5 0ZM4.0625 4.375C4.08854 4.19271 4.19271 4.08854 4.375 4.0625H5.625C5.80729 4.08854 5.91146 4.19271 5.9375 4.375V10.3125H6.875C7.05729 10.3385 7.16146 10.4427 7.1875 10.625C7.16146 10.8073 7.05729 10.9115 6.875 10.9375H4.375C4.19271 10.9115 4.08854 10.8073 4.0625 10.625C4.08854 10.4427 4.19271 10.3385 4.375 10.3125H5.3125V4.6875H4.375C4.19271 4.66146 4.08854 4.55729 4.0625 4.375ZM10.1172 5.23438L9.60938 5.82031C9.47917 5.97656 9.33594 5.98958 9.17969 5.85938C9.04948 5.72917 9.03646 5.58594 9.14062 5.42969L9.60938 4.84375C9.97396 4.42708 10.4297 4.19271 10.9766 4.14062C11.4974 4.11458 11.9792 4.28385 12.4219 4.64844C12.8125 5.01302 13.0339 5.45573 13.0859 5.97656C13.112 6.4974 12.9557 6.96615 12.6172 7.38281L10.0781 10.3125H13.125C13.3073 10.3385 13.4115 10.4427 13.4375 10.625C13.4115 10.8073 13.3073 10.9115 13.125 10.9375H9.375C9.24479 10.9375 9.15365 10.8724 9.10156 10.7422C9.04948 10.638 9.0625 10.5339 9.14062 10.4297L12.1484 6.99219C12.3828 6.67969 12.487 6.35417 12.4609 6.01562C12.4349 5.65104 12.2786 5.35156 11.9922 5.11719C11.7057 4.85677 11.3802 4.73958 11.0156 4.76562C10.651 4.79167 10.3516 4.94792 10.1172 5.23438Z" fill="#595A5B" />
                                                            </svg>
                                                            <p>{t('Change / set the PIN code of the card')}</p>
                                                        </button>
                                                    </li>
                                                    <li className="dashboard-finance-section-card-section-details-section-content-list-pin-item">
                                                        <button onClick={() => this.unblockFunc()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" viewBox="0 0 25 19" fill="none">
                                                                <path d="M14 15.9062C14.8854 15.2031 15.5885 14.3698 16.1094 13.4062C16.2135 13.25 16.3568 13.2109 16.5391 13.2891C16.6953 13.3932 16.7344 13.5365 16.6562 13.7188C16.1094 14.7344 15.3542 15.6328 14.3906 16.4141C13.0885 17.3776 11.6823 17.9635 10.1719 18.1719C8.66146 18.3802 7.1901 18.1979 5.75781 17.625C4.35156 17.0781 3.14062 16.1667 2.125 14.8906C1.13542 13.5885 0.536458 12.1823 0.328125 10.6719C0.119792 9.16146 0.302083 7.6901 0.875 6.25781C1.42188 4.85156 2.33333 3.64062 3.60938 2.625C4.91146 1.63542 6.31771 1.03646 7.82812 0.828125C9.33854 0.619792 10.8099 0.802083 12.2422 1.375C13.6484 1.92188 14.8724 2.83333 15.9141 4.10938L17.125 5.75V1.0625C17.151 0.880208 17.2552 0.776042 17.4375 0.75C17.6198 0.776042 17.724 0.880208 17.75 1.0625V6.6875C17.724 6.86979 17.6198 6.97396 17.4375 7H11.8125C11.6302 6.97396 11.526 6.86979 11.5 6.6875C11.526 6.50521 11.6302 6.40104 11.8125 6.375H16.8125L15.4062 4.5C13.9479 2.72917 12.138 1.71354 9.97656 1.45312C7.84115 1.16667 5.84896 1.71354 4 3.09375C2.22917 4.55208 1.21354 6.36198 0.953125 8.52344C0.666667 10.6589 1.21354 12.651 2.59375 14.5C4.05208 16.2708 5.86198 17.2865 8.02344 17.5469C10.1589 17.8333 12.151 17.2865 14 15.9062Z" fill="#595A5B" />
                                                            </svg>
                                                            <p>{t('Reset incorrect PIN attempts')}</p>
                                                        </button>
                                                    </li>
                                                </ul>}
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-finance-section-card-section-operation-section" style={{ width: '51%' }}>
                                    <div className="dashboard-finance-section-card-section-operation-section-background">
                                        {step != 0 ?
                                            <div className="dashboard-finance-section-card-section-details-section-content-pin">
                                                <form className="dashboard-finance-section-card-section-details-section-content-pin-content">
                                                    <h3>{step == 3 ? t('Enter the one-time code') : t("Change / set the PIN code of the card")}</h3>
                                                    <p>{step == 1 ? t("Enter the new PIN code", { cardNumber: card.organizedCardNumber }) : step == 2 ? t("Re-enter the new PIN code", { cardNumber: card.organizedCardNumber }) : t('OTP has been sent to your number', { phoneNumber: mobile })}</p>
                                                    {step == 3 && <img src={smsConfirmationIcon} className="registration-container-icon" alt="smsConfirmationIcon" />}
                                                    <div className="registration-container-sms-confirmation">
                                                        {code.map((ref, index) => (
                                                            <input
                                                                autoComplete="off"
                                                                key={index}
                                                                className={`registration-container-sms-confirmation-numbers ` + index}
                                                                ref={ref}
                                                                type={step === 3 ? "text" : "password"}
                                                                value={code[index]?.current?.value}
                                                                placeholder={step == 3 ? "0" : "•"}
                                                                autoFocus={index === 0}
                                                                onInput={(e) => this.insertCodeNumber(e.target.value)}
                                                                onFocus={() => this.handleFocus(index)}
                                                                onKeyDown={(e) => this.deleteCodeNumber(index, e)}
                                                            />
                                                        ))}
                                                    </div>
                                                    {feedbackMessage ? <p className="registration-container-validation-feedback-message" style={{ color: 'red' }}>{t(feedbackMessage)}</p> : null}
                                                    {step == 3 ?
                                                        <div className="registration-container-resend w-100">
                                                            <div className="registration-container-resend-container">
                                                                <div className="registration-container-resend-container-icon">
                                                                    <img src={commentAltLines} className="registration-container-resend-container-icon-img" alt="commentAltLines" />
                                                                </div>
                                                                <button type='button' className="registration-container-resend-container-button" disabled={timer != 0} onClick={() => this.sendOtpForCardPinChange()}>{t('resend the code')}</button>
                                                            </div>
                                                            <span className="registration-container-resend-timer">{this.fancyTimeFormat(timer)}</span>
                                                        </div> :
                                                        <div className="dashboard-finance-section-card-section-details-section-content-pin-content-button-group">
                                                            {[...Array(9).keys()].map(num => num + 1).concat(0).map(num => (
                                                                <button type='button' key={num} onClick={() => this.insertCodeNumber(num)}>{num}</button>
                                                            ))}
                                                        </div>
                                                    }
                                                    <div className="dashboard-finance-section-card-section-details-section-content-pin-content-footer-button-group">
                                                        <button type='button' onClick={() => window.location.reload()}>{t("Back")}</button>
                                                        <button type='submit' className={code.every(item => item.current?.value) && timer ? 'active' : ''} disabled={!code.every(item => item.current?.value) || !timer} onClick={(e) => this.continue(e)}>{t("Set")}</button>
                                                    </div>
                                                </form>
                                            </div>
                                            :
                                            <div className="dashboard-last-operations-section-content pt-5">
                                                <img src={cardBlockIcon} alt="cardBlockIcon" className="dashboard-last-operations-section-content-image mt-5" />
                                                <p className="dashboard-last-operations-section-content-status mb-4">{t('pin_settings')}</p>
                                                <ul className="dashboard-last-operations-section-content-invisible-list">
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                    <li className="dashboard-last-operations-section-content-invisible-list-item">
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                                            <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        )
    }
}

export default translate("translation")(PINChange);